/** Период по умолчанию: с 01.01.2026 по сегодня (пользователь может изменить в фильтре). */
export const DEFAULT_START_DATE = '2026-01-01';

export function todayDateISO() {
  const t = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}`;
}

function isoDate(d) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Последние N календарных дней включительно (сегодня — последний день). */
export function presetLastDays(days) {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - (days - 1));
  return { start_date: isoDate(start), end_date: isoDate(end) };
}

/** С 1 января текущего года по сегодня. */
export function presetYearToDate() {
  const end = new Date();
  const start = new Date(end.getFullYear(), 0, 1);
  return { start_date: isoDate(start), end_date: isoDate(end) };
}

export function defaultDateRangeFilters() {
  return { company: null, start_date: DEFAULT_START_DATE, end_date: todayDateISO() };
}
